import { useState } from 'react'

import { faEye } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedNumber } from 'react-intl'

import { FormattedMessage, Tooltip } from '@b-stock/fe-core/bstock-react'

import { Stat } from './Stat'

export const ViewCount = ({ viewCount }: { viewCount: number | undefined }) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  if (typeof viewCount === 'undefined') return null

  return (
    <>
      <Stat ref={setRef}>
        <FontAwesomeIcon icon={faEye} />
        <span>
          <FormattedNumber value={viewCount} />
        </span>
      </Stat>

      {ref ? (
        <Tooltip referenceElement={ref} containerElement={ref}>
          <FormattedMessage
            id="Auction.details.statsBar.tooltip.viewers"
            values={{ amount: viewCount }}
          />
        </Tooltip>
      ) : null}
    </>
  )
}
